<template>
  <el-card class="box-card">
    <el-dialog title="Imprimir Etiquetas" center :visible.sync="dialog">
      <el-form>
        <el-card v-for="itemData of tablePool" :key="itemData.id">
          <el-descriptions :title="itemData.delivery.contents" size="small">
            <template slot="extra">
              <el-button type="info" size="small" title="Imprimir em PDF" v-if="itemData.tag" icon="el-icon-printer"
              @click="download(itemData.delivery.cep, itemData.tag, 'pdf', 'application/pdf')" circle></el-button>
            </template>            
            <el-descriptions-item label="Nome">{{ itemData.delivery.name }}</el-descriptions-item>
            <el-descriptions-item label="Telephone">{{ itemData.delivery.phone }}</el-descriptions-item>
            <el-descriptions-item label="Peso">{{ itemData.weight }}</el-descriptions-item>
            <el-descriptions-item label="Endereço">{{ itemData.delivery.address }}</el-descriptions-item>
            <el-descriptions-item label="CEP">{{ itemData.delivery.cep}}</el-descriptions-item>
            <el-descriptions-item label="Bairro">{{ itemData.delivery.neighborhood}}</el-descriptions-item>
            <el-descriptions-item label="Cidade">{{ itemData.delivery.city}} - {{ itemData.delivery.state}}</el-descriptions-item>
        </el-descriptions>            
        </el-card>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">OK</el-button>
      </span>
    </el-dialog>
    <div slot="header" class="clearfix">
      <el-col :lg="4">
        Motoboy <small>({{ total }} registros)</small>
      </el-col>
      <el-col :lg="20" class="right">
        <el-button icon="el-icon-plus" class="right" type="primary" @click="add()">Novo Serviço</el-button>
        <el-pagination class="right" :page-size="records" background :pager-count="5" @current-change="fetch"
          @size-change="changeSize" :current-page.sync="page" layout="sizes, prev, pager, next" :page-sizes="[
            50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
          ]" :total="total"></el-pagination>
      </el-col>
    </div>
    <el-card shadow="hover">
      <el-form :model="ruleForm" :inline="true" ref="ruleForm">
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item :label="$t('periodo')" prop="name">
              <el-date-picker v-model="ruleForm.range" type="daterange" align="right" unlink-panels clearable
                range-separator="à" format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"></el-date-picker>
            </el-form-item>
            <el-form-item :label="user.type === '1' || user.type === '3' ? $t('cliente') : $t('filial')" prop="name"
              v-if="user.type !== '5'">
              <CustomerList v-model="ruleForm.customer" v-bind:multiple="true"
                v-bind:customerType="user.type === '2' ? 3 : 0" @selected="selected" />
            </el-form-item>
            <el-form-item :label="$t('status')" prop="name">
              <el-select
                ref="customer"
                v-model="ruleForm.status"
                v-on:keyup.native.enter="enter"
                placeholder="Selecione um status"
              >
                <el-option key="" label="Todos" value=""></el-option>
                <el-option key="open" label="Aberto" value="open"></el-option>
                <el-option key="confirm" label="Confirmada" value="confirm"></el-option>
                <el-option key="bill" label="Faturada" value="bill"></el-option>
              </el-select>
            </el-form-item>
            <el-button size="mini" type="info" @click="fetch()">Filtrar</el-button>&nbsp;
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div class="container-fluid py-4">
      <div class="row">
        <PrepostHomeDashColumn title="Total Serviços" :value="dash.total" color="bg-gradient-info" icon="ni-world"  />
        <PrepostHomeDashColumn title="Valor Venda" :value="dash.pricetable" color="bg-gradient-primary" icon="ni-money-coins"  />
        <PrepostHomeDashColumn v-if="userType !== '2' && userType !== '5'" title="Valor Custo" :value="dash.cost" color="bg-gradient-orange" icon="ni-money-coins"  />
      </div>
    </div>

    <el-alert v-if="tableData.filter(x => x.status === 'opem').length > 0">Aviso</el-alert>
    
    <el-table :data="tableData" stripe ref="tableData" size="mini" style="width: 100%"
      :default-sort="{ prop: 'name', order: 'ascending' }">
      <el-table-column prop="status" label="Status">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'open'">Aberta</el-tag>
          <el-tag v-else-if="scope.row.status === 'confirm'">Confimada</el-tag>
          <el-tag v-else-if="scope.row.status === 'delivered'">Entregue</el-tag>
          <el-tag v-else-if="scope.row.status === 'bill'">Faturada</el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="shippingName" label="Transportadora"></el-table-column>
      <el-table-column sortable prop="orderId" label="Ordem"></el-table-column>
      <el-table-column sortable prop="createdAt" label="Data"></el-table-column>
      <el-table-column sortable prop="cost" label="Custo">
        <template slot-scope="scope">
          {{  format(scope.row.cost) }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="pricetable" label="Venda">
        <template slot-scope="scope">
          {{  format(scope.row.pricetable) }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="weight" label="Peos"></el-table-column>
      <el-table-column width="280" align="center">
        <template slot-scope="scope">
          <el-button type="danger" size="small" v-if="scope.row.status === 'open'" icon="el-icon-delete"
            @click="remove(scope.row.id)" circle></el-button>
          <el-button type="primary" size="small" title="Imprimir essa etiqueta" v-if="scope.row.status === 'confirm'" icon="el-icon-printer"
            @click="print(scope.$index, scope.row)" circle></el-button>
          <!--el-button type="warning" size="small" title="Editar essa solicitação" icon="el-icon-edit"
            @click="edit(scope.$index, scope.row)" circle></el-button-->
          <el-button type="success" size="small" title="Solicitar motoboy agora" icon="el-icon-phone-outline" v-if="scope.row.status === 'open'"
            @click="add(scope.$index, scope.row)" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
    <br />
  </el-card>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import moment from "moment";
import "moment/locale/pt-br";
import { MotoboyService } from "@/services/customers/motoboy.services";
import PrepostHomeDashColumn from './components/PrepostHomeDashColumn';

export default {
  name: "MotoboyPage",
  components: {
    CustomerList,
    PrepostHomeDashColumn
  },
  data() {
    return {
      ruleForm: {
        range: [new Date().setDate(new Date().getDate() - 30), new Date()],
        customer: [],
        status: '',
      },
      tableData: [],
      tablePool: [],
      dash: {
        total: 0,
        cost: 0,
        pricetable: 0,
      },
      total: 0,
      records: 50,
      page: 1,
      dialog: false,
      user: {
        type: '2',
        name: '',
      }
    };
  },
  methods: {
    format(value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(value);
    },
    selected(list, name) {
      console.log('list', list, name)
      this.ruleForm.customer = list;
    },
    add(index, row) {
      console.log('row', row)
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      MotoboyService.request(row.id)
        .then((response) => {
          console.log('response request', response)
          vm.tableData[index].status = "confirm";
          vm.tableData[index].orderId = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    print(index, row) {
      console.log('row', row)
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      MotoboyService.print(row.id)
        .then((response) => {
          console.log('response', response)
          this.tablePool = [];
          for (let i=0; i<row.pool.length; i++) {
            const poolData = row.pool[i];
            poolData.tag = response.pdf[i] ? response.pdf[i].content_base64 : null;
            poolData.zpl = response.zpl[i] ? response.zpl[i].content_base64 : null;
            poolData.delivery = JSON.parse(poolData.delivery);
            this.tablePool.push(poolData);
            console.log(poolData);
          }
          this.dialog = true;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    remove(id) { 
      this.$message({
        type: "error",
        message: "Erra solicitação possui atendimentos realizados, não é possivel eliminar",
      });
    },
    edit(index, row) { },
    changeSize(size) {
      const vm = this;
      vm.records = size;
      vm.fetch();
    },
    download(zipcode, content, type, context) {
      var downloadLink = document.createElement("a");
      downloadLink.href = `data:${context};base64,${content}`;
      downloadLink.download = `etiqueta-${zipcode}.${type}`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
    },
    fetch(page) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      if (page) vm.page = page;
      MotoboyService.filter({
        records: vm.records,
        page: vm.page,
        customer: vm.ruleForm.customer,
        status: vm.ruleForm.status,
        startAt: s,
        finishedAt: f,
      })
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
          vm.dash.total = response.totals.total;
          vm.dash.cost = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(response.totals.cost);
          vm.dash.pricetable = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(response.totals.pricetable);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    }
  },
  mounted() {
    const vm = this;
    console.log('mounted')
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.user.name = response.name;
        console.log('fetch')
        vm.fetch();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>

<style>
.el-drawer__body {
  overflow-y: auto !important;
}
</style>
